import { CompletionScreen } from '@/features/setup/screens';
export default CompletionScreen;
